<template>
  <v-flex xs12 sm8 md4 lg4>
    <v-card class="elevation-4 pa-3">
      <v-card-text>
        <div class="layout column align-center">
          <img
            src="@/assets/logo-120x120.png"
            :alt="sistem.app_title"
            height="120"
          />
          <h1
            class="mt-3 mb-5 display-1 font-weight-regular"
            :class="`${sistem.app_theme}--text`"
          >
            Tentang Aplikasi
          </h1>
        </div>
        <div class="layout column">
          <v-chip
            :class="`${sistem.app_theme} darken-2`"
            label
            text-color="white"
          >
            <v-avatar>
              <v-icon>business</v-icon>
            </v-avatar>
            {{ sistem.company }}
          </v-chip>
          <v-chip :class="`${sistem.app_theme} darken-2`" small outline>
            <v-avatar>
              <v-icon>call</v-icon>
            </v-avatar>
            {{ sistem.company_phone }}
          </v-chip>
          <v-chip :class="`${sistem.app_theme} darken-2`" small outline>
            <v-avatar>
              <v-icon>email</v-icon>
            </v-avatar>
            {{ sistem.company_email }}
          </v-chip>
          <v-chip :class="`${sistem.app_theme} darken-2`" outline small>
            <v-avatar>
              <v-icon>apps</v-icon>
            </v-avatar>
            {{ sistem.app_title }} &copy; {{ new Date().getFullYear() }}, versi
            {{ sistem.app_version }}
          </v-chip>
        </div>
      </v-card-text>
      <v-card-actions>
        <public-menus></public-menus>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState } from "vuex";
import PublicMenus from "@/components/public/PublicMenus";

export default {
  name: "tentang-aplikasi",
  components: {
    PublicMenus
  },
  computed: {
    ...mapState("sistem", ["sistem"])
  }
};
</script>
